import React, { useState, useContext } from "react";
import AuthContext from "../../contexts/AuthContext";

import styles from "./User.module.css";
import cogoToast from "cogo-toast";
import { navigate } from "hookrouter";
import api from "../../actions/common";
import UserAvatarEditor from "./UserAvatarEditor";
import UserCoverEditor from "./UserCoverEditor";

const EditUser = () => {
  const { token } = useContext(AuthContext);
  const { user } = useContext(AuthContext);
  const [bio, setBio] = useState(user.bio);
  const [imageEditor, setImageEditor] = useState(null);
  const [coverImageEditor, setCoverImageEditor] = useState(null);
  const [loading, setLoading] = useState(false);

  const submitData = async (blob) => {
    var formdata = new FormData();
    formdata.append('bio', bio);
    formdata.append('avatar_link', blob);

    const resp = await api.put('/users/updateProfile', token, formdata, setLoading);
    console.log(resp);

    if (resp.success || resp.status) {
      cogoToast.success("Success");
      navigate("/user");
    } else {
      if (resp.message) {
        cogoToast.error(resp.message);
      } else {
        cogoToast.error("Something Went Wrong");
      }
    }
  };

  const onSubmit = () => {
    if (imageEditor && imageEditor.current) {
      imageEditor.current.getImage().toBlob((blob) => submitData(blob));
    } else {
      cogoToast.error("Please add an image");
    }
  };

  const uploadCoverImage = () => {
    if (coverImageEditor && coverImageEditor.current) {
      coverImageEditor.current.getImage().toBlob(async (blob) => {
        var formdata = new FormData();
        formdata.append('cover_photo', blob);
        const resp = await api.put('/users/uploadCover', token, formdata, setLoading);
        if (resp.success || resp.status) {
          cogoToast.success("Success");
          navigate("/user");
        } else {
          if (resp.message) {
            cogoToast.error(resp.message);
          } else {
            cogoToast.error("Something Went Wrong");
          }
        }
      });
    } else {
      cogoToast.error("Please select an image");
    }
  };

  return (
    <div className={styles.user}>
      <div className={styles.editContainer}>
        <h3>Edit Profile</h3>
        <Edit
          onSubmit={onSubmit}
          bio={bio}
          setBio={setBio}
          imageEditor={imageEditor}
          setImageEditor={setImageEditor}
          coverImageEditor={coverImageEditor}
          setCoverImageEditor={setCoverImageEditor}
          uploadCoverImage={uploadCoverImage} />
      </div>
    </div>
  );
};

const Edit = ({ bio, setBio, onSubmit, imageEditor, setImageEditor, coverImageEditor, setCoverImageEditor, uploadCoverImage }) => {
  return (
    <div className={styles.edit}>
      <UserCoverEditor
        imageEditor={coverImageEditor}
        setImageEditor={setCoverImageEditor}
      />
      <button
        type="submit"
        className={styles.submit}
        onClick={uploadCoverImage}
      >
        Upload Cover image
      </button>
      <div className={styles.row}>
        <UserAvatarEditor
          imageEditor={imageEditor}
          setImageEditor={setImageEditor}
        />
        <Field name={"About You"}>
          <textarea
            className={styles.field}
            style={{ height: 200, resize: "none" }}
            name="bio"
            value={bio}
            onChange={e => setBio(e.target.value)}
          />
        </Field>
      </div>
      <buton
        type="submit"
        className={styles.submit}
        onClick={onSubmit}
      >
        Submit
      </buton>
    </div>
  );
};

const Field = ({ children, name }) => {
  return (
    <div className={styles.formItem}>
      <div className={styles.label}>{name}</div>
      {children}
    </div>
  );
};

export default EditUser;
